import { Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import { WclService } from '@compumark/analyst-selection-tool-client';
import { Resolve } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class WCLAdminResolver implements Resolve<any> {
  constructor(private wclService: WclService) {}

  resolve(): Observable<any> {
    const addOnsObs = this.wclService.getAllAddOns();
    const locObs = this.wclService.getBrandLocations();
    const wclApisObs = this.wclService.getWclApis();

    return forkJoin([addOnsObs, locObs, wclApisObs]).pipe(
      map(([addOns, locations, wclApis]) => {
        return { addOns, locations, wclApis };
      }),
    );
  }
}
